export const services = [
    {
        duration: "500",
        image: "assets/img/services/1.png",
        title: "Optimization"
    },
    {
        duration: "1000",
        image: "assets/img/services/2.png",
        title: "Market Analysis"
    }, {
        duration: "500",
        image: "assets/img/services/3.png",
        title: "Concept & Idea"
    }, {
        duration: "500",
        image: "assets/img/services/4.png",
        title: "Development"
    },
]
